import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import FundManagementTable from './FundManagementTable';
import FundDetails from './FundDetails';
import UpcomingProducts from './UpcomingProducts';
import { ListContainer } from 'components';

const FundManagement = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={`${path}/details/:fundId`} component={FundDetails} />
                <Route path={`${path}/upcoming`} component={UpcomingProducts} />
                <Route path={path} render={() => <FundManagementTable />} />
            </Switch>
        </ListContainer>
    );
};

export default FundManagement;
